import { useMemo, type ReactNode } from "react";

import { NautilusApiContext } from "./NautilusApiContext";

export const NautilusApiContextProvider = ({ hostId, api, children }: NautilusApiContext & { children: ReactNode }) => (
  <NautilusApiContext.Provider value={useMemo(() => ({ api, hostId }), [hostId, api])}>
    {children}
  </NautilusApiContext.Provider>
);
